import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'thumbs-up-banner',
    templateUrl: './thumbs-up.component.html',
    styleUrls: ['./thumbs-up.component.css'],
    standalone: false
})
export class ThumbsUpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
